import { pick } from "lodash";
export const NEW_ID_PREFIX = "NEW_ITEM";

const getTempId = () => `${NEW_ID_PREFIX}-${Date.now()}`;

export const createEmptyTerm = () => {
  const id = getTempId();
  return {
    caseSensitive: false,
    changeTo: [],
    description: "",
    id,
    isNew: true,
    language: "all",
    occurrences: 0,
    term: "",
  };
};

export const createEmptyCategory = (name = "") => {
  return {
    description: "",
    id: getTempId(),
    isNew: true,
    name,
    terms: [],
  };
};

export const createEmptyWatchwordList = ({ createdBy, name = "" }) => {
  const createdOn = new Date().toISOString();

  return {
    categories: [createEmptyCategory("Default Category")],
    createdOn,
    createdBy,
    default: false,
    description: "",
    id: getTempId(),
    isNew: true,
    isLockedByAnotherUser: false,
    lockedBy: null,
    name,
    types: [],
    updatedOn: createdOn,
    updatedBy: createdBy,
  };
};

const termProps = [
  "caseSensitive",
  "changeTo",
  "description",
  "language",
  "term",
];

export const getRequestBody = (categories = [], removeIds = false) => {
  const result = [];
  let terms;

  for (const category of categories) {
    const {
      id: categoryId,
      isNew: isNewCategory,
      terms: categoryTerms = [],
      ...restOfCat
    } = category;

    terms = [];

    for (const {
      id: termId,
      isNew: isNewTerm,
      ...restOfTerm
    } of categoryTerms) {
      terms.push({
        ...pick(restOfTerm, termProps),
        id: !removeIds && !isNewTerm ? termId : undefined,
      });
    }

    result.push({
      ...restOfCat,
      id: !removeIds && !isNewCategory ? categoryId : undefined,
      terms,
    });
  }

  return result;
};
